<template>
  <footer class="app-footer">
    <a href="https://enateinnova.com" target="_blank">SCE</a> &copy; 2019
    <span class="float-right">Developed by <a href="https://enateinnova.com" target="_blank">ENATE Innova SL</a></span>
  </footer>
</template>
<script>
export default {
  name: 'app-footer'
}
</script>



// WEBPACK FOOTER //
// Footer.vue?2e6eb329